<nav
  class="flex justify-between w-[210px] h-[100%] bg-[var(--background-nav-color)] text-[var(--text-nav-secondary)]"
  [ngClass]="{ 'w-[210px] transition-all duration-200 ease-in-out transform': !hideFullMenu, 'w-[72px]': hideFullMenu }"
>
  <ul class="pt-3 size-full">
    @for (module of modules; track module.title; let idx = $index) {
      <div class="relative">
        @if (activeModule === module.title) {
          <svg-icon
            class="absolute w-[25px] z-10"
            name="menu_pointer"
            [ngClass]="{ 'left-[190px]': !hideFullMenu, 'left-[54px] top-[4px]': hideFullMenu }"
            color="var(--pointer-nav-primary)"
          ></svg-icon>
        }

        <li
          class="flex item-center cursor-pointer px-6 py-2 bg-[var(--background-nav-color)]"
          [ngClass]="{ 'justify-center': hideFullMenu }"
          [attr.tabindex]="idx"
          aria-hidden="true"
          role="button"
        >
          <div
            class="flex flex-col"
            (mouseenter)="showChildrenOnHover(module.title)"
            (mouseleave)="hoveredModule = ''; hideFullMenu = originalState"
          >
            <div class="flex flex-row" (click)="navigateToModule(module.title, module.name)">
              <svg-icon
                [name]="module.icon"
                size="LG"
                [color]="
                  activeModule === module.title || parentRoute === module.name
                    ? 'var(--text-nav-primary)'
                    : 'var(--text-nav-secondary)'
                "
              ></svg-icon>

              @if (!hideFullMenu) {
                <div
                  class="pl-4 nav-text text-bold text-base"
                  [ngClass]="{ 'text-[var(--text-nav-primary)]': activeModule === module.title || parentRoute === module.name }"
                >
                  {{ module.title }}
                </div>
              }
            </div>

            @if (
              ((activeModule === module.title || parentRoute === module.name) &&
                module?.children?.length &&
                !hideFullMenu) ||
              hoveredModule === module.title
            ) {
              <div class="flex flex-col ml-10 mt-2">
                @for (child of module.children; track child.title) {
                  <span
                    class="cursor-pointer relative"
                    [ngClass]="{ 'text-[var(--text-nav-primary)]': activeModule === child.title }"
                    (click)="navigateToModule(module.title, module.name, child)"
                  >
                    @if (activeModule === child.title) {
                      <svg-icon
                        class="absolute w-[25px] z-10"
                        name="menu_pointer"
                        [ngClass]="{ 'left-[122px] top-[-8px]': !hideFullMenu }"
                        color="var(--pointer-nav-primary)"
                      ></svg-icon>
                    }

                    {{ child.title }}
                  </span>
                }
              </div>
            }
          </div>
        </li>
      </div>
    }
  </ul>
</nav>
